exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".widget-head[data-v-136d5220]{border:1px solid #3540512b;background:#d7e3e5;color:#000;padding:0 20px}.panel-body[data-v-136d5220]{background-color:#fff;border:1px solid #3540511f}.btn-update-price[data-v-136d5220]{background-color:#e0e0e0;border:1px solid #e0e0e0;margin-bottom:10px;width:100%;background-color:#fff}.btn-update-price[data-v-136d5220]:hover{background-color:#f1f1f1}.btn-update-price[data-v-136d5220]:active{background-color:#d6d6d6}.product-search-container[data-v-136d5220]{display:grid;flex-direction:column;grid-template-columns:85% 15%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-136d5220","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Product.vue
// module id = Vk0k
// module chunks = 101